export const LOADING_FALLBACK_VALUE = "***";

export const alertMessages = {
  default: "Uwaga! ta zmiana jest nieodwracalna.",
};

export const conditionTypes = {
  AHR_ACCEPTANCE_REQUIRED: "Akceptacja przez AHR",
  ACCEPT_ONLY: "Akceptacja przez AHR",
  ACTIVE_FORM: "Oczekuje na uzupełnienie danych",
  BARCODE: "Dokument",
  EMPLOYEE_REQUIRED: "Oczekuje na osobę główną",
  FINANCING_CHANGE_REQUIRED: "Zmiana finansowania",
  PARENT_REQUIRED_AUTO: "Oczekuje na świadczenie główne",
  WAITING_FOR_PARENT: "Oczekuje na świadczenie główne",
  DOCUMENT_REQUIRED: "Akceptacja dokumentu potrącenia z wynagrodzenia",
  SIGNED_DOCUMENT_REQUIRED: "Wymagany podpisany dokument e\u2011podpisem",
};

export const ACCEPTED_REQUIREMENT_SUCCESS_ONE =
  "Pomyślnie zaakceptowano wymaganie";
export const ACCEPTED_REQUIREMENT_SUCCESS_OTHER =
  "Pomyślnie zaakceptowano wymagania";

export const ACCEPTED_REQUIREMENT_FAILURE_ONE =
  "Nie udało się zaakceptować wymagania";
export const ACCEPTED_REQUIREMENT_FAILURE_OTHER =
  "Nie udało się zaakceptować wymagań";

export const REJECT_BENEFIT_SUCCESS = "Pomyślnie odrzucono świadczenie";
export const REJECT_BENEFIT_FAILURE = "Nie udało się odrzucić świadczenia";
